/**
 * The `step` attribute controls the allowed numeric increments for this input.
 * Example: pricePrecision = 2 → step = 0.01
 *          pricePrecision = 0 → step = 1
 * This ensures users can only enter values with the correct number of decimal places.
 * If pricePrecision is invalid, the default step is 1.
 * @param pricePrecision - number of decimal places allowed
 * @returns step value for input field
 */
export const getStepForCurrencyPrecision = (pricePrecision: number): number => {
  const hasValidPrecision = pricePrecision !== undefined && pricePrecision > 0;

  if (!hasValidPrecision) return 1;
  if (pricePrecision > 1) {
    return Number(`${(0).toFixed(pricePrecision - 1)}1`);
  }
  return 0.1;
};
